import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

export const Protected = () => {
  const data = JSON.parse(Cookies.get("validation"));
  return data?.validationToken && <Outlet />;
};

export const ProtectedCardInfo = () => {
  useEffect(() => {
    if (window.location.pathname !== "/super-card-details") {
      sessionStorage.removeItem("dob");
    }
  }, [window.location.pathname]);
  const data = JSON.parse(sessionStorage.getItem("dob"));
  return data ? <Outlet /> : <Navigate to="/super-card" />;
};
